import { CHANNELS, getChannelName } from "../../App";
import { Link } from "react-router-dom";

const titles = {
    martinservera: "Martin & Servera Restauranghandel",
    galatea: "Galatea",
    raddamat: "Rädda Mat",
    restaurangbutiker: "Restaurangbutiker",
    gronsakshallen: "Grönsakshallen",
    fiskhallen: "Fiskhallen",
    kotthallen: "Kötthallen",
};

function BrandList() {
    const getTitle = (ch) => titles[ch] ?? getChannelName(ch);

    return (
        <div className="l-container">
            <ul className="l-list">
                {CHANNELS.map((channel) => (
                    <li key={channel} className="l-list__item">
                        <Link to={`/${channel}`} className="c-listcard" aria-label={getTitle(channel)}>
                            <span className="c-listcard__title">{getTitle(channel)}</span>
                            <i className="fa fa-chevron-right c-listcard__chevron" aria-hidden="true" />
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}
export default BrandList;
